import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography
} from "@mui/material";


export const StyledConfirmDialog = {
  TitleContainer: styled(DialogTitle)(({ theme, open }) => ({
    backgroundColor: `${theme.palette.primary.main}`,
    borderBottom: "1px solid green",
    boxSizing: "border-box",
    textAlign: "center",
    color: "white",
    padding: "5px 120px 5px 120px",
  })),
  DialogContent: styled(DialogContent)(({ theme }) => ({
    textAlign: "center",
    padding: 0,
    margin: 25,
  })),
  DialogActions: styled(DialogActions)(({ theme }) => ({
    margin: 10,
  })),
  LoadingContainer: styled('div')(({ theme }) => ({
    marginBottom: "30px",
  })),
  DialogContentContainer: styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    margin: "10px",
    gap: 30
    // paddingLeft: "15%",
    // paddingRight: "15%"
  })),
}

export const StyledAttachPdfDialog = {
  AdjuntarFormularioDialog: styled(Dialog)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  })),
  LoadingContainer: styled('div')(({ theme }) => ({
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  })),
  DialogText: styled(Typography)(({ theme }) => ({
    textAlign: "center",
    marginTop: "10px",
    marginBottom: "10px"
  })),
}